// extracted by mini-css-extract-plugin
module.exports = {"container":"CancelCall_container__2jhKz","show":"CancelCall_show__3EaUc"};